import React from 'react';
import Header from '../../components/Header/Header';

// import { Container } from './styles';

function Faq() {
  return (
  <div className="my-width" style={{ direction: "rtl", textAlign: "right", padding: "2rem 1rem" }}>
  <Header faq={true}/>
  <ul style={{ paddingRight: "1.5rem", lineHeight: 2, listStylePosition: "inside" }}>

<li>1.        کلیه فعالیت های نسل فردا منطبق با قوانین جمهوری اسلامی ایران میباشد.</li>

<li>2.      جهت ثبت و سفارش آگهی، ابتدا باید ثبت نام انجام گیرد و پس از تایید اطلاعات ثبت نام، سفارش آگهی میسر میباشد.</li>

<li>3.      هزینه ها هنگام ثبت در پیش نمایش فاکتور نمایش داده خواهد شد.</li>

<li>4.      در حال حاضر فقط کاربران دفاتر پست و نمایندگی ها تایید خواهند شد.</li>

<li>5.      پس از ثبت آگهی و تایید اطلاعات و انجام پرداخت یک شماره پیگیری صادر خواهد شد که در صورت بروز هرگونه مشکل امکان پاسخگویی و پشتیبانی از طریق آن انجام میگیرد.</li>

<li>6.      در صورتی که ثبت آگهی قبل از ساعت 12 انجام گیرد، تاریخ چاپ دوروز کاری و پس از ساعت12 سه روز کاری پس از روز ثبت نام خواهد بود.</li>

<li>7.     روز کاری به معنی روز شنبه تا پنج شنبه هر هفته، به استثنای تعطیلات عمومی در ایران است.</li>

<li>8.     پس از چاپ آگهی در روزنامه نسل فردا، یک نسخه کاغذی از آن برای سفارش دهنده، به آدرس مذکور در فرم ثبت آگهی، ارسال خواهد شد.</li>

<li>9.      در آگهیهای مفقودی مدارک، کلیه مدارک مربوط به یک نفر، در یک آگهی قابل سفارش میباشد.</li>

<li>10.      نسل فردا به اطلاعات خصوصی اشخاصى که از خدمات سایت استفاده میکنند، احترام گذاشته و از آن محافظت میکند. لطفا در صورت مشاهده هرگونه تخلف، مراتب را از طریق کانالهای ارتباطی ذکر شده در بخش تماس، با ما در میان بگذارید.</li>

<li>11.        محتویات این صفحه در هر زمانی قابل تغییر است و این حق برای "روزنامه نسل فردا "محفوظ بوده که بدون اطلاع و هماهنگی قبلی، اقدام به، به روزرسانی و یا تغییر در محتوای این صفحه کند. کاربران موظف هستند که به صورت دوره ای به این صفحه مراجعه کرده تا از تغییرات احتمالی در قوانین آگاه شوند. همچنین " روزنامه نسل فردا " بعد از هر بار به روزرسانی خبری مبنی بر تغییرات در این صفحه را در قسمت اخبار منتشر خواهد کرد</li>

  </ul>
  </div>)
}

export default Faq;